<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container">
        <ul class="navbar-nav mr-auto">
          <li v-if="auth && !isSalesOnly" class="nav-item">
            <router-link :to="{ name: 'invoices'}" class="nav-link cursor-pointer">Акты</router-link>
          </li>
          <li v-if="auth && !isSalesOnly" class="nav-item">
            <router-link :to="{ name: 'tasks'}" class="nav-link cursor-pointer">Задания</router-link>
          </li>
          <li v-if="auth && !isSalesOnly" class="nav-item">
            <router-link to="/plans" class="nav-link cursor-pointer">Планы</router-link>
          </li>
          <li v-if="auth" class="nav-item">
            <router-link to="/sales" class="nav-link cursor-pointer">Продажи</router-link>
          </li>
          <li v-if="auth && !isSalesOnly" class="nav-item">
            <router-link to="/arrears" class="nav-link cursor-pointer">Дебиторка</router-link>
          </li>
          <li v-if="auth && !isSalesOnly" class="nav-item">
            <router-link to="/payments" class="nav-link cursor-pointer">Платежи</router-link>
          </li>
          <li v-if="auth && !isSalesOnly && isBonusViewAllowed" class="nav-item">
            <router-link to="/bonuses" class="nav-link cursor-pointer">Бонусы</router-link>
          </li>
          <li v-if="auth" class="nav-item">
            <router-link to="/balance" class="nav-link cursor-pointer">Баланс</router-link>
          </li>
        </ul>
        <ul class="nav pull-right">
          <li>
            <div v-if="!auth">
              <router-link to="/login" tag="button" class="btn btn-outline-primary my-2 my-sm-0">
                Вход
              </router-link>
            </div>
            <div v-if="auth">
              <span style="margin-right: 10px"> {{ userName }} </span>
              <button @click="onLogout" class="btn btn-outline-primary my-2 my-sm-0">Выход</button>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: "Header",
  data() {
    return {}
  },

  computed: {
    auth() {
      return this.$store.getters.isAuthenticated
    },
    isSalesOnly() {
      return this.$store.getters.isSalesOnly
    },
    isBonusViewAllowed() {
      return this.$store.getters.isBonusViewAllowed
    },
    userName() {
      return this.$store.getters.userName
    },
  },

  methods: {
    onLogout() {
      this.$store.dispatch('logout')
          .then(() => {
            this.$router.replace('/login');
          })
    },
  }
});
</script>

<style scoped>
.selected {
  font-weight: bold;
}

</style>
